export enum OutgoingInvoiceCreateUponEnum {
  OPENED_SO = 'opened_sales_order',
  PACKED_DN = 'packed_up_delivery_note',
}
